"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spacer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _getSpacerStyle = require("@cbhq/cds-common/utils/getSpacerStyle");
var _tokens = require("../tokens");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Spacer component is for adding spacing gap between two dom nodes. If no horizontal or vertical
 * spacing size is provided, Spacer will stretch to fill up available space left in the parent container.
 */
const Spacer = /*#__PURE__*/(0, _react.memo)(function Spacer({
  as: Component = 'span',
  flexGrow,
  flexShrink,
  flexBasis,
  horizontal,
  vertical,
  maxHorizontal,
  maxVertical,
  minHorizontal,
  minVertical,
  testID
}) {
  return /*#__PURE__*/_react.default.createElement(Component, {
    "aria-hidden": "true",
    "data-testid": testID,
    role: "presentation",
    style: (0, _getSpacerStyle.getSpacerStyle)({
      flexGrow,
      flexShrink,
      flexBasis,
      horizontal,
      vertical,
      maxHorizontal,
      maxVertical,
      minHorizontal,
      minVertical,
      spacingScaleValues: _tokens.spacing
    })
  });
});
exports.Spacer = Spacer;